import React from "react";

interface Props { }

export const ReplayIconComponent: React.SFC<Props> = () => {
  return (
    // tslint:disable:max-line-length
    <svg width="100%" height="100%" viewBox="0 0 25 21" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M13.5 3C9.35787 3 6 6.35786 6 10.5H3C3 4.70101 7.70101 0 13.5 0C19.299 0 24 4.70101 24 10.5C24 16.299 19.299 21 13.5 21C11.7546 21 10.1046 20.573 8.65288 19.8163L10.0394 17.156C11.0732 17.6948 12.2487 18 13.5 18C17.6421 18 21 14.6421 21 10.5C21 6.35786 17.6421 3 13.5 3Z" />
      <path d="M4.5 18L0 10.5L9 10.5L4.5 18Z" />
    </svg>
    // tslint:enable:max-line-length
  );
};
